import { Action, createReducer, on } from '@ngrx/store';

import { Service } from './services.models';
import {
  BookingSelectServicesApiActions,
  BookingSelectServicesActions,
  BookingSessionStorageActions,
} from '@modules/booking/store/services/services.actions';

export interface ServicesState {
  entities: Array<Service>;
  selectedServices: Array<string>;
  loading: boolean;
}

const initialState: ServicesState = {
  entities: [],
  selectedServices: [],
  loading: false,
};

const servicesReducer = createReducer(
  initialState,
  on(
    BookingSelectServicesActions.loadServices,
    (state): ServicesState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    BookingSelectServicesActions.selectService,
    (state, { uuid }): ServicesState => ({
      ...state,
      selectedServices: [...state.selectedServices, uuid],
      loading: false,
    })
  ),
  on(
    BookingSelectServicesActions.unselectService,
    (state, { uuid }): ServicesState => ({
      ...state,
      selectedServices: state.selectedServices.filter((item) => item !== uuid),
      loading: false,
    })
  ),
  on(
    BookingSelectServicesActions.unselectAllServices,
    (state): ServicesState => ({
      ...state,
      selectedServices: [],
      loading: false,
    })
  ),
  on(
    BookingSelectServicesApiActions.loadSuccess,
    (state, { services }): ServicesState => ({
      ...state,
      loading: false,
      entities: services,
    })
  ),
  on(
    BookingSelectServicesApiActions.loadFailure,
    (state): ServicesState => ({
      ...state,
    })
  ),
  on(
    BookingSessionStorageActions.setSelectedServices,
    (state, { selectedServices }): ServicesState => ({
      ...state,
      selectedServices: selectedServices,
    })
  )
);

export function reducer(state: ServicesState | undefined, action: Action) {
  return servicesReducer(state, action);
}
